import * as styledElements from "../ElementsTableStyles";
import Icon from "../../../../common/Icon";
import React from "react";
import { BillableElement } from "../../../../../reducers/uploadedBoard";
import { useDeleteBoardElement } from "../../../../../utils/hooks/commonly-stored/uploaded-board/updates/billOfMaterials";

export default function DeleteElementButton({
  elements,
  disableEditing,
}: {
  elements: BillableElement[];
  disableEditing: boolean;
}) {
  const deleteBoardElement = useDeleteBoardElement();

  const deleteElement = () => {
    if (!disableEditing) {
      deleteBoardElement(
        elements.map((element) => ({
          elementName: element.name,
          elementId: element.id,
        })),
      );
    }
  };

  return (
    <styledElements.EditButton
      onClick={disableEditing ? undefined : deleteElement}
      disabled={disableEditing}
    >
      <Icon src="/icons/trash.svg" alt="trash" />
    </styledElements.EditButton>
  );
}
